import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findCitizens = (headers, params) => {
    let query = buildQuery(params, ["idNumber", "phoneNumber", "fullName", "addressLine"]);
    if (params.filters.phoneNumber?.value) {
        query += `&phoneNumber=${params.filters.phoneNumber.value?.trim()}`;
    }
    if (params.filters.fromDate?.value) {
        query += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params.filters.toDate?.value) {
        query += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    if (params.filters.idNumber?.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/citizens/search${query}`, {
        headers,
    });
};
